/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
import Glide from '@glidejs/glide';
import { throttle } from '../utils';

const sliders = document.querySelectorAll('.glide.slider');
sliders.forEach((slider) => {
  let props = JSON.parse(slider.getAttribute('data-props'));
  if (!props || Array.isArray(props)) {
    props = {};
  }

  new Glide(slider, {
    ...props,
    animationTimingFunc: 'ease-in-out',
    animationDuration:   200,
  }).mount();

  const sliderControls = () => {
    const { breakpoints } = props;
    const matchedBreakpoint = '';
    const queries = Object.keys(breakpoints);
    const match = queries.find((breakpoint) => {
      const { matches: responsiveMatch } = window.matchMedia(
        `(max-width: ${breakpoint}px)`
      );
      return responsiveMatch;
    });

    const arrows = slider.querySelector('.glide__arrows');

    if (match) {
      if (breakpoints[match].showControls) {
        arrows.classList.add('show-arrows');
      } else {
        arrows.classList.remove('show-arrows');
      }
    } else if (!matchedBreakpoint && props.showControls) {
      arrows.classList.add('show-arrows');
    } else {
      arrows.classList.remove('show-arrows');
    }
  };

  // Responsive Controls setup
  window.addEventListener('resize', throttle(sliderControls, 300));
  sliderControls();
});
